import { ApiResponse } from "api/api.d";
import { api } from "api/api";
import { AccountResponse } from "dto/accounts/response/UserInfo.d";

export const accountAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerAccount: builder.query<ApiResponse<AccountResponse>, void>({
      query: () => ({
        url: "/getCustomerAccount", // Endpoint API của bạn
        method: "POST", // Hoặc "GET" nếu cần
        functionName: "getCustomerAccount", // Chức năng cần thiết từ header
      }),
    }),
  }),
});

export const { useGetCustomerAccountQuery } = accountAPI;
